export default function promotion() {
    function togglePromo($this) {
        if ($this.hasClass('cpwicon-arrow-down')) {
            $this.removeClass('cpwicon-arrow-down').addClass('cpwicon-arrow-up');
            if ($('.promoInput').hasClass('hideImp')) {
                $('.promoInput').removeClass('hideImp');
            }
            $('#promotionCode').focus();
        } else {
            $this.removeClass('cpwicon-arrow-up').addClass('cpwicon-arrow-down');
            if (!$('.promoInput').hasClass('hideImp')) {
                $('.promoInput').addClass('hideImp');
            }
            $('.promoError').text('');
            if ($('.promoError').hasClass('promo-error')) {
                $('.promoError').removeClass('promo-error');
            }
            $('#promotionCode').removeClass('promoErrorInput');
            $('#promotionCode').val('');
        }
    }
    function toggleAppliedPromo($this) {
        if ($this.hasClass('cpwicon-arrow-down')) {
            $this.removeClass('cpwicon-arrow-down').addClass('cpwicon-arrow-up');
            if ($('.appliedPromotionList').hasClass('hideImp')) {
                $('.appliedPromotionList').removeClass('hideImp');
            }
            if ($('.addMorePromotion').hasClass('hideImp')) {
                $('.addMorePromotion').removeClass('hideImp');
            }
            if ($('.promoError').hasClass('hideImp')) {
                $('.promoError').removeClass('hideImp');
            }
            if (!$('.promoError').hasClass('promo-error')) {
                $('.promoError').addClass('promo-error');
            }
        } else {
            $this.removeClass('cpwicon-arrow-up').addClass('cpwicon-arrow-down');
            if (!$('.appliedPromotionList').hasClass('hideImp')) {
                $('.appliedPromotionList').addClass('hideImp');
            }
            if (!$('.addMorePromotion').hasClass('hideImp')) {
                $('.addMorePromotion').addClass('hideImp');
            }
            if (!$('.promoError').hasClass('hideImp')) {
                $('.promoError').addClass('hideImp');
            }
            if ($('.promoError').hasClass('promo-error')) {
                $('.promoError').removeClass('promo-error');
            }
            if (!$('.promoInputAnother').hasClass('hideImp')) {
                $('.promoInputAnother').addClass('hideImp');
            }
            $('.promoError').text('');
            $('#promotionCode').val('');
            $('#promotionCode').removeClass('promoErrorInput');
        }
    }
    function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }
    function removeFromCartAnalytics(dataRef) {
        if ($('.removeBasketDeal' + dataRef).length) {
            const rawJson = $('.removeBasketDeal' + dataRef).attr('data-analytic-insurance-item');
            if (rawJson) {
                let dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'remove_from_cart',
                    items: [JSON.parse($('.removeBasketDeal' + dataRef).attr('data-analytic-insurance-item'))],
                });
            }
        }
    }
    $(document).ready(function() {
        $(document).on('click', '.removeBasketDeal', function(e) {
            e.preventDefault();
            let dataRef = $(this).attr('data-ref');
            let dataBasketLine = $(this).attr('data-basket-line');
            if (dataRef == 'show-popup') {
                $('.basketModalSubmit').attr('data-ref', dataBasketLine);
                $('#basketRemoveWarningModal').modal('show');
                $('body').addClass('basketNoScroll');
            } else {
                removeFromCartAnalytics(dataBasketLine);
                $('#removeProduct' + dataBasketLine).submit();
            }
        });
        $(document).on('click', '.basketModalClose', function(e) {
            e.preventDefault();
            $('.basketModalSubmit').attr('data-ref', '');
            $('#basketRemoveWarningModal').modal('hide');
            $('body').removeClass('basketNoScroll');
        });
        $(document).on('click', '.basketModalSubmit', function(e) {
            e.preventDefault();
            let dataRef = $(this).attr('data-ref');
            if (dataRef != '') {
                $(this).attr('data-ref', '');
                $('#basketRemoveWarningModal').modal('hide');
                $('body').removeClass('basketNoScroll');
                removeFromCartAnalytics(dataRef);
                $('#removeProduct' + dataRef).submit();
            }
        });
        $(document).on('click', '.promoHeading', function(e) {
            e.preventDefault();
            if ($('.togglePromo').length) {
                togglePromo($('.togglePromo'));
            }
            if ($('.toggleAppliedPromo').length) {
                toggleAppliedPromo($('.toggleAppliedPromo'));
            }
        });
        $(document).on('keyup', '.makeToUpper', function() {
            $(this).val($(this).val().toUpperCase().replace(/ /g, ''));
        });
        $(document).on('click', '.promoSubmit', function(e) {
            e.preventDefault();
            let promotionCode = $('#promotionCode').val();
            let promoAction = $('.promotionForm').attr('action');
            $('.global-msg-boxes').html('');
            const error_array = {
                'Invalid': 'Sorry, the promo code entered isn\'t valid.',
                'Expired': 'Sorry, the promo code entered has expired.',
                'Minimum Upfront Cost not met': 'Sorry, the promo code is not valid as the upfront cost is lower than the discount offered.',
                'Technical Error': 'Sorry, the promo code could not be applied due to a technical error. Please try again.',
                'Same Promotion Code being entered in \'Add another\' field': 'This promotion code is already applied to your basket.',
                'Invalid Basket Content': 'Sorry, this promo code can\'t be used with the contents of your basket.',
                'Required Multi-Bucket Basket Content': 'This promo code can only be used when all required items are in your basket'
            };
            if (promotionCode != '') {
                if (promotionCode.length >= 5 && promotionCode.length <= 20) {
                    $.ajax({
                        type: 'POST',
                        url: promoAction,
                        data: {
                            promotionCode: promotionCode
                        },
                        dataType: 'JSON',
                        beforeSend: function() {
                            $('.promoSubmit').html('<img src="https://media.secure-mobiles.com/cpw/icons/loader.gif" class="loader-promotion"></img>');
                            $('.promoError').text('');
                            if ($('.promoError').hasClass('promo-error')) {
                                $('.promoError').removeClass('promo-error');
                            }
                            $('#promotionCode').removeClass('promoErrorInput');
                            $('#promotionCode').prop('readonly', true);
                            $('.promoSubmit').prop('disabled', true);
                            $('.promoSubmit').addClass('promoSubmitLoader').removeClass('promoSubmit');
                            $('body').addClass('noScrollToTop');
                        },
                        success: function(res) {
                            $('.promoSubmitLoader').addClass('promoSubmit').removeClass('promoSubmitLoader');
                            $('.promoSubmit').html('Apply');
                            $('body').removeClass('noScrollToTop');
                            $('#promotionCode').prop('readonly', false);
                            $('.promoSubmit').prop('disabled', false);
                            if (res.result == 'success') {
                                $('#promotionCode').val('');
                                $('.basketTotals').html(res.basketTotalsHtml);
                                $('.promoContent').html(res.promoAppliedHtml);
                                $.each(res.basketLine, function(basketId, originalVal) {
                                    $('.itemDiscountedUpfront_' + basketId).html('\
                                        <span class="itemOriginalUpfront itemOriginalUpfront_' + basketId + '">' + originalVal + '</span>\
                                    ' + res.basketItemId[basketId]);
                                    if ($('.removeBasketDeal' + basketId).length && $('.removeBasketDeal' + basketId).attr('data-ref') == 'no-popup' && !res.popupPromotionApplied.includes(basketId)) {
                                        $('.removeBasketDeal' + basketId).attr('data-ref', 'show-popup');
                                    }
                                    if (!$('.itemDiscountedUpfront_' + basketId).hasClass('itemDiscountedUpfrontSingle')) {
                                        $('.itemDiscountedUpfront_' + basketId).addClass('itemDiscountedUpfrontSingle');
                                    }
                                    $('.itemPromoApplied_' + basketId).html('\
                                        <div class="itemPromoCode">' + promotionCode + '</div>\
                                        <div class="itemPromoBasketMessage"><p>' + res.promotionalMessage + '</p></div>\
                                    ');
                                    if ($('.itemPromoApplied_' + basketId).hasClass('accPromoApplied')) {
                                        $('.itemPromoApplied_' + basketId).addClass('mb-15');
                                    }
                                });
                                let items = [];
                                $.each(res.addedPromotionRecord, function(basketId, basketValue) {
                                    let pc_applied = $('div#' + basketId + '_pc_applied input').length;
                                    if (pc_applied > 0) {
                                        $('#' + basketId + '_pc').val(basketValue.code);
                                    } else {
                                        let input = document.createElement('input');
                                        input.setAttribute('type', 'hidden');
                                        input.setAttribute('id', basketId + '_pc');
                                        input.setAttribute('name', basketId + '_pc');
                                        input.setAttribute('data-identifier', basketValue.internalPromotionIdentifier);
                                        input.setAttribute('data-discountValue', basketValue.discountValue);
                                        input.setAttribute('data-type', basketValue.type);
                                        input.setAttribute('value', basketValue.code);
                                        $('div#' + basketId + '_pc_applied').append(input);
                                    }
                                    if (basketValue.pairBasketId != '' && !res.popupPromotionApplied.includes(basketValue.pairBasketId) && $('.removeBasketDeal' + basketValue.pairBasketId).length && $('.removeBasketDeal' + basketValue.pairBasketId).attr('data-ref') == 'no-popup') {
                                        $('.removeBasketDeal' + basketValue.pairBasketId).attr('data-ref', 'show-popup');
                                    }
                                    let $elem = $('#' + basketId + '_uc');
                                    let promoAdded = JSON.parse($elem.attr('data-analytic-json-object'));
                                    let promoCurrent = JSON.parse($elem.attr('data-analytic-json-object'));
                                    promoAdded.offers = promoAdded.offers || [];
                                    promoCurrent.offers = promoCurrent.offers || [];
                                    let promoPush = {
                                        'id': basketValue.internalPromotionIdentifier,
                                        'type': basketValue.type,
                                        // 'offer_type': basketValue.offerType,
                                        'price_value': basketValue.discountValue,
                                        'offer_category': basketValue.offerCategory,
                                        // 'internal_offer_name': basketValue.promotionName,
                                        // 'offer_code': basketValue.code,
                                        'offer_detail': basketValue.offerDetail,
                                        // 'position': promoCurrent.offers.length + 1,
                                        'tier': basketValue.tier
                                    };
                                    if (!promoCurrent.offers.some(o => o.id === basketValue.internalPromotionIdentifier)) {
                                        promoCurrent.offers.push(promoPush);
                                    }
                                    promoAdded['offers'] = [promoPush];
                                    $elem.attr('data-analytic-json-object', JSON.stringify(promoCurrent));
                                    items.push(promoAdded);
                                });
                                dataLayer.push({
                                    'event': 'update_cart',
                                    'reason': 'promo added',
                                    'items': items,
                                    'trade-in': ($('#isTradeInApplied').length) ? $('#isTradeInApplied').val() : 'no',
                                    'timeStamp': {
                                        'timestampMs': Date.now(),
                                        'isoTimestamp': new Date(Date.now()).toISOString()
                                    }
                                });
                                $('.enter-promo').addClass('enterPromo');
                            } else {
                                dataLayer.push({
                                    'event': 'error',
                                    'errorCustomerException': [
                                        {
                                            'id': '',
                                            'message': res.message,
                                            'title': getKeyByValue(error_array, (res.message != '') ? res.message : 'Sorry, the promo code entered isn\'t valid.'),
                                            'type': 'Generic; Fixed Amount'
                                        }
                                    ],
                                    'timeStamp': {
                                        'timestampMs': Date.now(),
                                        'isoTimestamp': new Date(Date.now()).toISOString()
                                    }
                                });
                                if (!$('.promoError').hasClass('promo-error')) {
                                    $('.promoError').addClass('promo-error');
                                }
                                $('.promoError').text((res.message != '') ? res.message : 'Sorry, the promo code entered isn\'t valid.');
                                $('#promotionCode').addClass('promoErrorInput');
                            }
                        },
                        error: function() {
                            dataLayer.push({
                                'event': 'error',
                                'errorCustomerException': [
                                    {
                                        'id': '',
                                        'message': 'Sorry, the promo code could not be applied due to a technical error. Please try again.',
                                        'title': 'Technical Error',
                                        'type': 'Generic; Fixed Amount'
                                    }
                                ],
                                'timeStamp': {
                                    'timestampMs': Date.now(),
                                    'isoTimestamp': new Date(Date.now()).toISOString()
                                }
                            });
                            $('.promoSubmitLoader').addClass('promoSubmit').removeClass('promoSubmitLoader');
                            $('.promoSubmit').html('Apply');
                            $('body').removeClass('noScrollToTop');
                            $('#promotionCode').prop('readonly', false);
                            $('.promoSubmit').prop('disabled', false);
                            if (!$('.promoError').hasClass('promo-error')) {
                                $('.promoError').addClass('promo-error');
                            }
                            $('.promoError').text('Sorry, the promo code could not be applied due to a technical error. Please try again.');
                            $('#promotionCode').addClass('promoErrorInput');
                        }
                    });
                } else {
                    dataLayer.push({
                        'event': 'error',
                        'errorCustomerException': [
                            {
                                'id': '',
                                'message': 'Sorry, the promo code entered isn\'t valid',
                                'title': 'Invalid',
                                'type': 'Generic; Fixed Amount'
                            }
                        ],
                        'timeStamp': {
                            'timestampMs': Date.now(),
                            'isoTimestamp': new Date(Date.now()).toISOString()
                        }
                    });
                    if (!$('.promoError').hasClass('promo-error')) {
                        $('.promoError').addClass('promo-error');
                    }
                    $('.promoError').text("Sorry, the promo code entered isn't valid.");
                    $('#promotionCode').addClass('promoErrorInput');
                }
            } else {
                if (!$('#promotionCode')[0].checkValidity()) {
                    $('#promotionCode')[0].reportValidity();
                }
                if (!$('.promoError').hasClass('promo-error')) {
                    $('.promoError').addClass('promo-error');
                }
                $('.promoError').text('This value is not valid.');
                $('#promotionCode').addClass('promoErrorInput');
            }
        });
        $(document).on('click', '.addMorePromotion', function(e) {
            e.preventDefault();
            $(this).addClass('hideImp');
            $('.promoHeadingAnother').removeClass('hideImp');
            $('.promoInputAnother').removeClass('hideImp');
            if ($('.promoError').hasClass('promo-error')) {
                $('.promoError').removeClass('promo-error');
            }
            $('.promoError').text('');
            $('#promotionCode').val('');
            $('#promotionCode').prop('required', true);
            $('#promotionCode').focus();
            $('#promotionCode').removeClass('promoErrorInput');
        });
        $(document).on('click', '.toggleAnotherPromo', function(e) {
            e.preventDefault();
            $('#promotionCode').val('');
            if ($('.promoError').hasClass('promo-error')) {
                $('.promoError').removeClass('promo-error');
            }
            $('.promoError').text('');
            $('#promotionCode').removeClass('promoErrorInput');
            $('.addMorePromotion').removeClass('hideImp');
            $('.promoHeadingAnother').addClass('hideImp');
            $('.promoInputAnother').addClass('hideImp');
        });
        $(document).on('click', '.removePromotion', function(e) {
            e.preventDefault();
            let promotionCode = $(this).attr('data-promotion');
            $.ajax({
                type: 'POST',
                url: '/basket/voucher/remove',
                data: {
                    promotionCode: promotionCode
                },
                dataType: 'JSON',
                beforeSend: function() {
                    if ($('.promoError').hasClass('promo-error')) {
                        $('.promoError').removeClass('promo-error');
                    }
                    $('.promoError').text('');
                    $('#promotionCode').removeClass('promoErrorInput');
                    $('.loaderPromotion').attr('data-active-tasks', '1');
                    $('body').addClass('noScrollToTop');
                    $('.removePromotion').prop('disabled', true);
                },
                success: function(res) {
                    $('.removePromotion').prop('disabled', false);
                    $('.loaderPromotion').attr('data-active-tasks', '0');
                    $('body').removeClass('noScrollToTop');
                    if (res.result == 'success') {
                        $('.basketTotals').html(res.basketTotalsHtml);
                        $('.promoContent').html(res.promoAppliedHtml);
                        $.each(res.basketLine, function(basketId, originalVal) {
                            $('.itemOriginalUpfront_' + basketId).text('');
                            $('.itemDiscountedUpfront_' + basketId).text(originalVal);
                            if ($('.itemDiscountedUpfront_' + basketId).hasClass('itemDiscountedUpfrontSingle')) {
                                $('.itemDiscountedUpfront_' + basketId).removeClass('itemDiscountedUpfrontSingle');
                            }
                            $('.itemPromoApplied_' + basketId).html('');
                            if ($('.itemPromoApplied_' + basketId).hasClass('accPromoApplied')) {
                                $('.itemPromoApplied_' + basketId).removeClass('mb-15');
                            }
                            if ($('.removeBasketDeal' + basketId).length && $('.removeBasketDeal' + basketId).attr('data-ref') == 'show-popup') {
                                $('.removeBasketDeal' + basketId).attr('data-ref', 'no-popup');
                            }
                        });
                        $.each(res.promotionRemovedAnalytics, function(basketId, basketValue) {
                            if (basketValue.pairBasketId != '' && $('.removeBasketDeal' + basketValue.pairBasketId).length && $('.removeBasketDeal' + basketValue.pairBasketId).attr('data-ref') == 'show-popup') {
                                $('.removeBasketDeal' + basketValue.pairBasketId).attr('data-ref', 'no-popup');
                            }
                            let $elem = $('#' + basketId + '_uc');
                            let promoCurrent = JSON.parse($elem.attr('data-analytic-json-object'));
                            let promoRemoved = JSON.parse($elem.attr('data-analytic-json-object'));
                            // let removedPosition = null;
                            // promoCurrent.offers = (promoCurrent.offers || []).filter(function(offer) {
                            //     if (offer.id == basketValue.internalPromotionIdentifier) {
                            //         removedPosition = offer.position;
                            //         return false;
                            //     }
                            //     return true;
                            // }).map(function(offer, index) {
                            //     offer.position = index + 1;
                            //     return offer;
                            // });
                            $elem.attr('data-analytic-json-object', JSON.stringify(promoCurrent));
                            promoRemoved['offers'] = {};
                            promoRemoved['offers'] = [
                                {
                                    'id': basketValue.internalPromotionIdentifier,
                                    'type': basketValue.type,
                                    // 'offer_type': basketValue.offerType,
                                    'price_value': basketValue.discountValue,
                                    'offer_category': basketValue.offerCategory,
                                    // 'internal_offer_name': basketValue.promotionName,
                                    'offer_code': basketValue.code,
                                    // 'offer_detail': basketValue.offerDetail,
                                    // 'position': removedPosition,
                                    'tier': basketValue.tier
                                }
                            ];
                            dataLayer.push({
                                'event': 'update_cart',
                                'reason': 'promo removed',
                                'items': [promoRemoved],
                                'trade-in': ($('#isTradeInApplied').length) ? $('#isTradeInApplied').val() : 'no',
                                'timeStamp': {
                                    'timestampMs': Date.now(),
                                    'isoTimestamp': new Date(Date.now()).toISOString()
                                }
                            });
                            if ($('#' + basketId + '_pc').length) {
                                $('#' + basketId + '_pc').remove();
                            }
                        });
                    } else {
                        if (!$('.promoError').hasClass('promo-error')) {
                            $('.promoError').addClass('promo-error');
                        }
                        $('.promoError').text(res.message);
                    }
                }
            });
        });
        $(document).on('scroll touchmove mousewheel', '.noScrollToTop', function(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });
        $(document).on('keypress', '.restrictSpecial', function(e) {
            if (!((e.keyCode >= 65) && (e.keyCode <= 90) || (e.keyCode >= 97) && (e.keyCode <= 122) || (e.keyCode >= 48) && (e.keyCode <= 57))) {
                e.preventDefault();
            }
        });
        $(document).on('keypress', '#promotionCode', function() {
            if ($('.promoError').hasClass('promo-error')) {
                $('.promoError').removeClass('promo-error');
            }
            $('.promoError').text('');
            $('#promotionCode').removeClass('promoErrorInput');
        });
        $('.basket-remove-warning-modal').modal({
            backdrop: 'static',
            keyboard: false,
            show: false
        });
    });
}
